import $ from "jquery";

export function stroken() {	
	var lijstAccordion = $('#lijst-accordion');
	var lijstToelichting = $('#lijst-toelichting .card');

	lijstAccordion.on('click', '.btn', function() {
		if (window.innerWidth >= 992) {
			var body = $(this).closest('.card').find('.card-body').clone();
			lijstToelichting.empty().append(body);
			return false;
		}
	});

}